<style scoped>
    @import url("../../styles/mv/mv.scss");
</style>

<template>
    <div class="box_mv" v-if="!$store.state.flagMenuSup">

        <div v-if="flagLoadingCA"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="rgb(247,215,46)"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- MENU LATERAL -->
        <MenuLateralDashV2 v-if="!flagLoadingCA"/>

        <!-- PAINEL EXIBIDOR -->
        <div class="painelExibidor" :style="{'width':$store.state.widthDinamCA}" v-if="$store.state.flagExib && !flagLoadingCA">

            <router-view></router-view>

        </div>

    </div>
</template>

<script>
//import axios from 'axios'

import MenuLateralDashV2 from './MenuLateralDashV2'

export default {

    components:{
        MenuLateralDashV2,
    },

    data() {
        return {
            //
            flagLoadingCA:true, // desabilitar Loading depois de carregar as info da page.
            //
            //flagExib:true, // init versão large (state)
            // this.$store.state.widthDinamCA
            //widthDinam:'75%', // init versão large com menu aberto. Na versão small o menu é width=100% sempre.

            //
            strFlagMenuOpenItem:'Geral', // controle do item selecionado na página, pelo menu lateral.

        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        // -- STORAGE
        var creden = JSON.parse(localStorage.getItem('creden'))
        var contentUser = JSON.parse(localStorage.getItem('contentUser'))

        if (creden != null) {
            this.$store.state.flagLogadoDash = creden.flagLogadoDash
            this.$store.state.contentUser = contentUser
        }

        if (this.$store.state.flagLogadoDash == true) { // última alteração 07/10/2024

            this.$store.state.LarguraPageCA = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            var self = this

            // desabilitar overlay após requisição concluída.
            /*axios.get(self.$store.state.pathAxiosGetCA).then(function (res) {

                //console.log(res.data.result)

                // -- VERSÃO DE RECEBIMENTO PARA APENAS 1 CONTADOR.
                let c=0
                var liAux = []
                while (c<res.data.result.length) {
                    liAux.push({
                        'data':res.data.result[c].dataRcv.slice(0, 10),
                        'leitura':res.data.result[c].litrosConsumidos
                    })
                    c++
                }
                self.$store.state.liContadores = [
                    {
                        'classe':'Proj. UPinC Contadores LoRaWAN',
                        'liContadores':[
                            {
                                'id':'c1',
                                'nome':'UPinC Exemplo',
                                'classe':'Proj. UPinC Contadores LoRaWAN',
                                'coord':[40.279184, -7.504404],
                                'lileituras':liAux
                            }
                        ],
                    },
                ]

                //liContadores

                self.flagLoadingCA = false

                //self.$store.state.farm_li_names = res.data.result.names
                
                //self.$store.state.flag_loading_init_farm = false // desabilitar loading. Abrir page.
            })*/

            // AQUI DEVEM SER INICIALIZADAS AS HIERARQUIAS DE MALHAS, GRUPOS E CONTADORES. 20/01/2025
            self.flagLoadingCA = false // tmp enquanto nao ha axios. 20/01/2025

        } else {

            // -- reencaminhar para login.
            this.$router.push('/dashmain')
            return
        }
    }
}
</script>